import type { Milestone, PayoutFundingAvailability, ProjectFundingMilestone } from '../types';

/** Display copies only: stored milestone and transfer status stay unchanged. */
export function payoutPresentationMilestones(milestones: Milestone[], funding?: ProjectFundingMilestone[]): Milestone[] {
  return milestones.map(milestone => milestone.deliveryStatus === 'payout_failed' && funding?.some(item =>
    item.milestoneId === milestone.id && item.payoutAvailability?.status === 'awaiting_funds')
    ? { ...milestone, deliveryStatus: 'payout_processing' } : milestone);
}

export function payoutAvailabilityMessage(t: (key: string, options?: Record<string, unknown>) => string, availability: PayoutFundingAvailability, language: string) {
  const timestamp = Date.parse(availability.expectedAvailableAt ?? '');
  const date = Number.isFinite(timestamp) && timestamp > Date.now()
    ? new Intl.DateTimeFormat(language.startsWith('en') ? 'en-GB' : 'sv-SE', {
      dateStyle: 'long', timeZone: 'Europe/Stockholm'
    }).format(new Date(timestamp)) : null;
  const body = t('payoutAvailability.body');
  return date ? t('payoutAvailability.expected', { body, date }) : body;
}
